import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  cleanSessionCodeInput,
  isValidSessionCode,
  SESSION_CODE_LENGTH,
} from "@binogi-livequiz/shared";
import Wordmark from "../components/Wordmark";
import { LanguageSwitcher } from "../components/LanguageSwitcher";

export default function Home() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [code, setCode] = useState("");
  const [error, setError] = useState<string | null>(null);

  const handleEnter = useCallback(() => {
    const trimmed = code.trim().toUpperCase();
    if (!isValidSessionCode(trimmed)) {
      setError(t("home.error_invalid_code"));
      return;
    }
    navigate(`/join/${trimmed}`);
  }, [code, navigate, t]);

  return (
    <main className="min-h-full relative flex flex-col">
      {/* Language picker tucked into the corner — the centered Wordmark
          below the input is the only branding on this screen, no need
          for a second small one in a top header. */}
      <div className="absolute top-4 right-4">
        <LanguageSwitcher />
      </div>

      <section className="flex-1 flex flex-col items-center justify-center px-6">
        <div className="mb-12">
          <Wordmark size="lg" />
        </div>

        <div className="w-full max-w-sm bg-brand-ink2 rounded-2xl p-5 shadow-2xl shadow-black/30">
          <label htmlFor="gameCode" className="sr-only">
            {t("home.placeholder")}
          </label>
          <input
            id="gameCode"
            type="text"
            inputMode="text"
            autoComplete="off"
            autoCapitalize="characters"
            spellCheck={false}
            value={code}
            onChange={(e) => {
              setCode(cleanSessionCodeInput(e.target.value));
              setError(null);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") handleEnter();
            }}
            placeholder={t("home.placeholder")}
            className="w-full bg-brand-ink text-center text-2xl md:text-3xl font-bold tracking-[0.3em] py-4 rounded-xl outline-none focus:ring-2 focus:ring-brand-green placeholder:text-white/30 placeholder:tracking-normal placeholder:font-normal"
            autoFocus
          />
          <button
            type="button"
            onClick={handleEnter}
            disabled={code.length !== SESSION_CODE_LENGTH}
            className="w-full mt-3 bg-brand-green hover:bg-brand-greenHi disabled:opacity-40 disabled:cursor-not-allowed text-white font-bold py-4 rounded-xl text-lg transition-colors"
          >
            {t("home.enter")}
          </button>
        </div>

        {error && <p className="mt-4 text-sm text-brand-bad">{error}</p>}

        <p className="mt-12 text-white/40 text-xs text-center">
          {t("home.footer")}
        </p>
      </section>
    </main>
  );
}
